import React from 'react';

export function TrustCard({ title, desc }: { title: string; desc: string }): React.ReactElement {
  return (
    <div className="flex gap-3 rounded-md border border-hairline bg-white px-4 py-3.5 mb-2.5">
      <div className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-brand" />
      <div>
        <div className="text-small font-medium text-ink mb-1">{title}</div>
        <div className="text-tiny text-muted leading-relaxed">{desc}</div>
      </div>
    </div>
  );
}
